"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _currency = require("../../../utils/currency");
var _Bubble = _interopRequireDefault(require("../../Bubble"));
var _Button = _interopRequireDefault(require("../../Button"));
var _CancellationOff = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationOff"));
var _CancellationOn = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationOn"));
var _utils = require("../assets/utils");
var CollapsedCancellationPolicy = function CollapsedCancellationPolicy(_ref) {
  var returnType = _ref.returnType,
    currentStageEndDateISO = _ref.currentStageEndDateISO,
    isMobile = _ref.isMobile,
    hasInsurance = _ref.hasInsurance,
    _ref$onGetInsuranceCl = _ref.onGetInsuranceClick,
    onGetInsuranceClick = _ref$onGetInsuranceCl === void 0 ? function () {
      return null;
    } : _ref$onGetInsuranceCl,
    insuranceSelected = _ref.insuranceSelected,
    _ref$onDetailsClick = _ref.onDetailsClick,
    onDetailsClick = _ref$onDetailsClick === void 0 ? function () {
      return null;
    } : _ref$onDetailsClick,
    insurancePrice = _ref.insurancePrice,
    isCollapsed = _ref.isCollapsed,
    showPopup = _ref.showPopup,
    isSmall = _ref.isSmall,
    PopupComponent = _ref.PopupComponent,
    cancelled = _ref.cancelled,
    isHotelOnly = _ref.isHotelOnly,
    mobileCollapsedElRef = _ref.mobileCollapsedElRef;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var insuranceBtnText = !insuranceSelected ? /*#__PURE__*/_react["default"].createElement(StyledInsurance, null, /*#__PURE__*/_react["default"].createElement("span", null, t('cancellationPolicy.insuranceAdd', {
    context: isMobile ? 'mobile' : 'desktop'
  }), ' '), /*#__PURE__*/_react["default"].createElement("span", null, (0, _currency.formatCurrency)(insurancePrice || 0))) : /*#__PURE__*/_react["default"].createElement(StyledInsurance, null, t('cancellationPolicy.insuranceRemove', {
    context: isMobile ? 'mobile' : 'desktop'
  }));
  var getIconForReturnType = function getIconForReturnType() {
    if (cancelled) return /*#__PURE__*/_react["default"].createElement(_CancellationOff["default"], null);
    switch (returnType) {
      case 'full':
      case 'partial':
        return /*#__PURE__*/_react["default"].createElement(_CancellationOn["default"], null);
      case 'nothing':
        return /*#__PURE__*/_react["default"].createElement(_CancellationOff["default"], null);
      default:
        return null;
    }
  };
  var showInsuranceButton = hasInsurance && isCollapsed && !isSmall;
  var icon = getIconForReturnType();
  var collapsedTitleContent = (0, _utils.getCollapsedTitleContent)(isMobile, isHotelOnly, returnType, currentStageEndDateISO, cancelled);
  var handleClick = showPopup ? function () {
    return null;
  } : onDetailsClick;
  var UncollapseButton = /*#__PURE__*/_react["default"].createElement(StyledUncollapseButton, {
    isMobile: isMobile,
    onClick: handleClick,
    isSmall: isSmall
  }, ' ', /*#__PURE__*/_react["default"].createElement("span", null, t('checkout.extraRooms.more')));
  var UncollapseComponent = showPopup ? /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    renderExtras: function renderExtras() {
      return PopupComponent;
    },
    text: " ",
    width: "max",
    eventType: "click"
  }, UncollapseButton) : UncollapseButton;
  return /*#__PURE__*/_react["default"].createElement(StyledCancellationPolicyWrapper, {
    ref: mobileCollapsedElRef
  }, /*#__PURE__*/_react["default"].createElement(StyledCollapsedCancellationPolicy, null, /*#__PURE__*/_react["default"].createElement(StyledCollapedContent, {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledIcon, null, icon), /*#__PURE__*/_react["default"].createElement(StyledCollapsedTextPart, null, /*#__PURE__*/_react["default"].createElement(StyledCollapsedTitle, null, collapsedTitleContent), isCollapsed ? UncollapseComponent : null)), showInsuranceButton ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    primary: true,
    size: "none",
    onClick: onGetInsuranceClick
  }, insuranceBtnText) : null));
};
var StyledInsurance = _styledComponents["default"].span.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledInsurance",
  componentId: "sc-3cdug4-0"
})(["white-space:pre-line;"]);
var StyledCancellationPolicyWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCancellationPolicyWrapper",
  componentId: "sc-3cdug4-1"
})(["display:flex;flex-direction:column;"]);
var StyledCollapsedCancellationPolicy = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapsedCancellationPolicy",
  componentId: "sc-3cdug4-2"
})(["display:flex;flex-direction:column;"]);
var StyledCollapsedTitle = _styledComponents["default"].span.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapsedTitle",
  componentId: "sc-3cdug4-3"
})(["color:var(--black);font-size:14px;font-style:normal;font-weight:400;"]);
var StyledCollapedContent = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapedContent",
  componentId: "sc-3cdug4-4"
})(["display:flex;gap:4px;"]);
var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledIcon",
  componentId: "sc-3cdug4-5"
})(["height:16px;svg{height:16px;}"]);
var StyledCollapsedTextPart = _styledComponents["default"].div.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledCollapsedTextPart",
  componentId: "sc-3cdug4-6"
})(["display:flex;gap:4px;"]);
var StyledUncollapseButton = _styledComponents["default"].span.withConfig({
  displayName: "CollapsedCancellationPolicy__StyledUncollapseButton",
  componentId: "sc-3cdug4-7"
})(["color:var(--secondary);font-size:14px;font-style:normal;font-weight:400;cursor:pointer;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CollapsedCancellationPolicy__StyledButton",
  componentId: "sc-3cdug4-8"
})(["padding:12px 16px;margin-top:16px;"]);
var _default = exports["default"] = CollapsedCancellationPolicy;